import axios from 'axios'

/**
 * @desc Get Supplier Payment Adjustment History
 * @param {Number} page - page number to fetch
 * @param {Number} size - number of items per page
 * @param {String} query - Includes several search parameters
 */
export const fetchPaymentAdjustmentHistory = (page, size, query) => {
  let baseQuery = `page=${page}&size=${size}`
  if (query) baseQuery += `&${query}`

  return axios
    .get(`/authenticated/payment-adjustment?${baseQuery}`)
    .then((res) => res.data)
}

/**
 * @desc Get Payment Adjustment by ID
 * @param {String} paymentAdjustmentId
 */
export const fetchPaymentAdjustment = (paymentAdjustmentId) =>
  axios
    .get(`/authenticated/payment-adjustment/${paymentAdjustmentId}`)
    .then((res) => res.data)

/**
 * @desc Fetch PaymentAdjustment PDF
 */
export const fetchPaymentAdjustmentPdfUrl = (paymentAdjustmentId) =>
  axios
    .get(`/authenticated/payment-adjustment/${paymentAdjustmentId}/credit-note`)
    .then((res) => res.data)
